import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  throw new Error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set — copy .env.example to .env.local.',
  );
}

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Required for the invite / recovery flow. Supabase mails a link
    // with `#access_token=…&type=invite|recovery` in the fragment;
    // this option is what makes supabase-js parse those tokens and
    // establish a session so SetPasswordPage can call updateUser().
    // Without it, users saw "الرابط منتهي" on every reset attempt.
    detectSessionInUrl: true,
  },
});
